import React, { useState, useEffect } from 'react'
import { Loader } from '../../../components'
import {
  formatPrice,
  formatDiscount,
  formatPrecentage,
  getDiscount
} from '../../../helpers'
import ProductDescription from './ProductDescription'
import './ProductReferralLanding.css'

const ProductReferralLanding = ({
  productPayload,
  account,
  referralCode,
  referralDiscount = null,
  contactPhone,
  history,
  dispatchAddCart,
  dispatchSaveTransaction,
  transactionLoading,
  transactionPayload,
  authenticateAccount,
  voucherPayload,
  activeReferralCode
}) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    address: '',
    paymentMethod: 'Bayar di Tempat (COD - Cash on Delivery)'
  })
  const [quantity, setQuantity] = useState(1)
  const [pendingWhatsApp, setPendingWhatsApp] = useState(null)

  useEffect(() => {
    if (transactionPayload && pendingWhatsApp) {
      const { phone, text } = pendingWhatsApp
      setPendingWhatsApp(null)
      const baseUrl = window.location.origin
      const detailUrl = `${baseUrl}/pembelian/${transactionPayload}`
      const fullText = `Kode ${transactionPayload}%0ALink: ${detailUrl}%0A%0A${text}`
      window.open(`${process.env.REACT_APP_WHATSAPP_URL}${phone}&text=${fullText}`, '_blank')

      if (history) {
        history.push(`/pembelian/${transactionPayload}`)
      } else {
        window.location.href = `/pembelian/${transactionPayload}`
      }
    }
  }, [transactionPayload, pendingWhatsApp, history])

  if (!productPayload) return <Loader />

  const outOfStock = productPayload && (
    productPayload.has_stock === false ||
    productPayload.has_stock === 0 ||
    productPayload.has_stock === '0' ||
    productPayload.has_stock === 'false' ||
    productPayload.hasStock === false
  )

  const precentage = formatPrecentage(account, productPayload.discount, referralDiscount)
  const discountedPrice = formatDiscount(productPayload.price, precentage, 'Rp.')
  const originalPrice = formatPrice(productPayload.price, 'Rp.')

  const formattedReferralName = referralCode
    ? referralCode.replace(/[_]/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    : ''

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleIncreaseQuantity = () => {
    setQuantity(prev => prev + 1)
  }

  const handleDecreaseQuantity = () => {
    setQuantity(prev => (prev > 1 ? prev - 1 : 1))
  }

  const handleQuantityInputChange = (e) => {
    const val = parseInt(e.target.value, 10)
    if (isNaN(val) || val < 1) {
      setQuantity(1)
    } else {
      setQuantity(val)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (outOfStock) return

    const finalPrice = getDiscount(productPayload.price, precentage)
    const totalPrice = finalPrice * quantity

    if (dispatchSaveTransaction && !transactionLoading) {
      const data = {
        total: totalPrice,
        user_id: authenticateAccount ? authenticateAccount.id : null,
        name: formData.name,
        phone: formData.phone,
        address: formData.address,
        orders: [{
          quantity: quantity,
          price: Number(finalPrice),
          product_id: productPayload.id
        }],
        voucher_id: voucherPayload ? voucherPayload.id : null
      }

      if (activeReferralCode) {
        data.referral = activeReferralCode
      }

      const totalFormatted = formatPrice(totalPrice, 'Rp.')
      const text = `Produk: ${productPayload.name}%0A` +
        `Harga Satuan: ${discountedPrice}%0A` +
        `Jumlah: ${quantity}%0A` +
        `Total Bayar: ${totalFormatted}%0A` +
        `Nama: ${encodeURIComponent(formData.name)}%0A` +
        `No WA: ${encodeURIComponent(formData.phone)}%0A` +
        `Alamat: ${encodeURIComponent(formData.address)}`

      if (contactPhone) {
        setPendingWhatsApp({ phone: contactPhone, text })
      }

      dispatchSaveTransaction(data)
      return
    }

  }

  const handleGoToHome = (e) => {
    e.preventDefault()
    const targetPath = referralCode ? `/?referral=${referralCode}` : '/'
    if (history) {
      history.push(targetPath)
    } else {
      window.location.href = targetPath
    }
  }

  return (
    <div className="ref-landing-wrapper">

      {/* Main Container */}
      <main className="ref-main-container">
        <div>
          {/* Hero Image / Product Visual */}
          <div className="ref-hero-visual">
            <img
              src={process.env.REACT_APP_IMAGE_URL + productPayload.image}
              alt={productPayload.name || 'Produk Herbal'}
              className="ref-hero-img"
            />
            {outOfStock && (
              <div style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                backgroundColor: '#6c757d',
                color: '#ffffff',
                fontSize: '11px',
                fontWeight: 700,
                padding: '6px 12px',
                borderRadius: '9999px',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                zIndex: 2
              }}>
                Stok Habis
              </div>
            )}
          </div>

          {/* Product Header Section */}
          <div className="ref-header-section">
            {/* <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
              <span className="ref-badge-bpom">
                100% Alami &amp; BPOM
              </span>
              <span className="ref-rating">★ 4.9 (1.240 Terjual)</span>
            </div> */}
            <h1 className="ref-product-title">
              {productPayload.name}
            </h1>

            {/* Pricing Area */}
            <div className="ref-pricing-area">
              <span id="product-price" className="ref-price-discount">
                {discountedPrice}
              </span>
              <span id="original-price" className="ref-price-original">
                {originalPrice}
              </span>
              {Number(precentage) > 0 && (
                <span className="ref-badge-save">
                  Hemat {precentage}%
                </span>
              )}
            </div>
          </div>

          {/* Benefits / Pain Points */}
          <div className="ref-benefits-section">
            {productPayload.description && (
              <ProductDescription
                description={productPayload.description}
                style={{ marginTop: 0, marginBottom: 0 }}
              />
            )}
          </div>

          {/* Order Form Section */}
          <div className="ref-order-section">
            <h2 className="ref-section-title">Formulir Pemesanan Cepat</h2>
            <form id="order-form" onSubmit={handleSubmit}>
              <div className="ref-form-group">
                <label className="ref-form-label">Jumlah Pesanan</label>
                <div className="ref-quantity-control">
                  <button
                    type="button"
                    className="ref-qty-btn"
                    onClick={handleDecreaseQuantity}
                    disabled={quantity <= 1 || outOfStock}
                  >
                    -
                  </button>
                  <input
                    type="number"
                    min="1"
                    value={quantity}
                    onChange={handleQuantityInputChange}
                    className="ref-qty-input"
                    disabled={outOfStock}
                  />
                  <button
                    type="button"
                    className="ref-qty-btn"
                    onClick={handleIncreaseQuantity}
                    disabled={outOfStock}
                  >
                    +
                  </button>
                </div>
              </div>
              <div className="ref-form-group">
                <label className="ref-form-label">Nama Lengkap Penerima</label>
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="Contoh: Budi Yanto"
                  className="ref-form-input"
                  value={formData.name}
                  onChange={handleChange}
                  disabled={outOfStock}
                />
              </div>
              <div className="ref-form-group">
                <label className="ref-form-label">Nomor WhatsApp Aktif</label>
                <input
                  type="tel"
                  name="phone"
                  required
                  placeholder="Contoh: 08XXXXXXXXXXXX"
                  className="ref-form-input"
                  value={formData.phone}
                  onChange={handleChange}
                  disabled={outOfStock}
                />
              </div>
              <div className="ref-form-group">
                <label className="ref-form-label">Alamat Lengkap Pengiriman</label>
                <textarea
                  name="address"
                  required
                  rows="3"
                  placeholder="Nama Jalan, RT/RW, Kecamatan, Kota, Kode Pos"
                  className="ref-form-textarea"
                  value={formData.address}
                  onChange={handleChange}
                  disabled={outOfStock}
                ></textarea>
              </div>

              <input type="hidden" id="ref-input" name="ref" value={referralCode || ''} />
            </form>
          </div>
        </div>

        {/* Sticky Bottom CTA Button Container */}
        <div className="ref-sticky-cta">
          <button
            type="submit"
            form="order-form"
            className={`ref-btn-submit ${outOfStock ? 'ref-btn-submit-disabled' : ''}`}
            disabled={outOfStock}
          >
            <span>{outOfStock ? 'Stok Habis' : 'Pesan Sekarang'}</span>
            {!outOfStock && (
              <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px' }} viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </button>
          <div className="ref-footer-link">
            <a
              onClick={handleGoToHome}
              href={referralCode ? `/?referral=${referralCode}` : '/'}
            >
              Lihat Produk-Produk Lainnya? Klik di sini
            </a>
          </div>
        </div>
      </main>
    </div>
  )
}

export default ProductReferralLanding
